export default __webpack_public_path__ + "static/media/books.40a4f6af.jpg";